import { Link } from '@tanstack/react-router'
import { SparklesIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	Item,
	ItemActions,
	ItemContent,
	ItemTitle,
} from '@/shared/components/ui/item'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

export function AiScenariosRecommendation({ count }: { count: number }) {
	const { t } = useTranslation()

	return (
		<div className='mb-4 px-4'>
			<Item size='xs' variant='outline' className='bg-accent'>
				<ItemContent>
					<ItemTitle className='text-xs font-medium'>
						{`${count}`}{' '}
						{`${t('ai.scenarios_recommendation.title', {
							defaultValue: 'new AI scenarios recommended for you:',
						})}`}
					</ItemTitle>
				</ItemContent>
				<ItemActions>
					<Tooltip>
						<TooltipTrigger asChild>
							<Button asChild size='sm'>
								<Link to='/p/whatif/scenarios'>
									<SparklesIcon />
									{t('ai.scenarios_recommendation.explore_scenarios', {
										defaultValue: 'Explore scenarios',
									})}
								</Link>
							</Button>
						</TooltipTrigger>
						<TooltipContent>
							{t('ai.scenarios_recommendation.tooltip', {
								defaultValue: 'Explore AI-powered pricing scenarios',
							})}
						</TooltipContent>
					</Tooltip>
				</ItemActions>
			</Item>
		</div>
	)
}
